import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// Fixe current page redirect to self error:
// Uncaught NavigationDuplicated ... Navigating to current location is not allowed
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   if (originalPush) {
//     return originalPush.call(this, location).catch(err => err)
//   }
// }

// 路由列表
const routes = [
  {
    path: '/',
    name: 'home',
    meta: { title: '购课商城' },
    component: () => import('@/pages/home/index')
  },
  {
    path: '/classroom',
    name: 'classroom',
    meta: { title: '我的课堂' },
    component: () => import('@/pages/classroom/index')
  },
  {
    path: '/my',
    name: 'my',
    meta: { title: '我的' },
    component: () => import('@/pages/my/index')
  },
  {
    path: '/orders',
    name: 'orders',
    meta: { title: '我的订单' },
    component: () => import('@/pages/orders/index')
  },
  {
    path: '/subject',
    name: 'subject',
    meta: { title: '课程详情' },
    component: () => import('@/pages/subject/index')
  },
  {
    path: '/group/:id',
    name: 'group',
    meta: { title: '拼团详情' },
    component: () => import('@/pages/group/index')
  },
  {
    path: '/group/:id/share',
    name: 'groupShare',
    meta: { title: '拼团详情' },
    component: () => import('@/pages/group/share')
  },
  {
    path: '/group/:id/invite',
    name: 'groupInvite',
    meta: { title: '拼团邀请' },
    component: () => import('@/pages/group/invite')
  },
  {
    path: '/group/:id/success',
    name: 'groupSuccess',
    meta: { title: '拼团成功' },
    component: () => import('@/pages/group/success')
  },
  {
    path: '/group/:id/fail',
    name: 'groupFail',
    meta: { title: '拼团失败' },
    component: () => import('@/pages/group/fail')
  },
  {
    path: '/group/:id/poster',
    name: 'groupPoster',
    meta: { title: '拼团海报' },
    component: () => import('@/pages/group/poster')
  },
  {
    path: '/earlyAccess',
    name: 'earlyAccess',
    meta: { title: '1元体验7天' },
    component: () => import('@/pages/group/earlyAccess')
  },
  {
    path: '/earlyAccessGuide',
    name: 'earlyAccessGuide',
    meta: { title: '支付成功' },
    component: () => import('@/pages/group/earlyAccessGuide')
  },
  {
    path: '/service',
    name: 'service',
    meta: { title: '添加客服' },
    component: () => import('@/pages/service/index')
  },
  {
    path: '/learn',
    name: 'learn',
    meta: { title: '课程列表' },
    component: () => import('@/pages/classroom/learn')
  },
  {
    path: '/detail',
    name: 'detail',
    meta: { title: '正在学习' },
    component: () => import('@/pages/classroom/courseDetail')
  },
  {
    path: '/profit',
    name: 'profit',
    meta: { title: '推荐好友购课，赚奖学金' },
    component: () => import('@/pages/profit/index')
  },
  {
    path: '/invite/:id',
    name: 'invite',
    meta: { title: '拼团详情' },
    component: () => import('@/pages/invite/index')
  },
  {
    path: '/coupon',
    name: 'coupon',
    meta: { title: '我的优惠券' },
    component: () => import('@/pages/coupon/index')
  },
  {
    path: '/coupon/receive',
    name: 'couponReceive',
    meta: { title: '优惠券领取' },
    component: () => import('@/pages/coupon/receive')
  },
  {
    path: '/distributor',
    name: 'distributor',
    meta: { title: '分销商' },
    component: () => import('@/pages/distributor/index')
  },
  {
    path: '/distributor/history',
    name: 'distributorHistory',
    meta: { title: '历史明细' },
    component: () => import('@/pages/distributor/history')
  },
  {
    path: '/activity',
    name: 'activity',
    meta: { title: '免费领科学实验课' },
    component: () => import('@/pages/activity/index')
  },
  {
    path: '/activity/guide',
    name: 'activityGuide',
    meta: { title: '领取成功' },
    component: () => import('@/pages/activity/guide')
  },
  {
    path: '/activity/poem',
    name: 'activityPoem',
    meta: { title: '免费领古诗词课程' },
    component: () => import('@/pages/activity/poem/index')
  },
  {
    path: '/activity/poem/guide',
    name: 'activityPoemGuide',
    meta: { title: '领取成功' },
    component: () => import('@/pages/activity/poem/guide')
  },
  {
    path: '/activity/virus',
    name: 'activityVirus',
    meta: { title: '明明城堡病毒专题' },
    component: () => import('@/pages/activity/virus')
  },
  {
    path: '/gift',
    name: 'gift',
    meta: { title: '赠课记录' },
    component: () => import('@/pages/gift/index')
  },
  {
    path: '/gift/detail',
    name: 'giftDetail',
    meta: { title: '赠送好友' },
    component: () => import('@/pages/gift/detail')
  },
  {
    path: '/gift/receive',
    name: 'receiveGift',
    meta: { title: '领取赠课' },
    component: () => import('@/pages/gift/receive')
  },
  {
    path: '/activity/steward',
    name: 'activitySteward',
    meta: { title: '明明城堡' },
    component: () => import('@/pages/activity/steward/index')
  },
  {
    path: '/tool/debug',
    name: 'toolDebug',
    meta: { title: '调试工具' },
    component: () => import('@/pages/tool/debug')
  }
]

const router = new Router({
  // mode: 'history',
  routes
})

// 拦截器
router.beforeEach((to, from, next) => {
  document.title = to.meta.title // 设置网页标题
  next()
})

export default router
